<template>
  <div class="provincias container">
    <custom-select
      label="Provincia"
      name="provincia"
      :value="value"
      @input="onChange"
      @focus="$emit('focus')"
      :items="provincias"
    />
  </div>
</template>

<script>
import { provincias } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "ProvinceList",
  components: { CustomSelect },
  props: {
    value: String
  },
  computed: {
    provincias() {
      return provincias;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped></style>
